import React, { Component } from 'react';
import { connect } from 'react-redux'
import { SingleDatePicker } from 'react-dates';
import AutoComplete from '../common/autoComplete';
import Button from '../common/button';
import './styles.css';

function hightLightText(str, val) {
    var index = str.toLowerCase().indexOf(val.toLowerCase());
    if(index > 0) {
      return [
        str.substring(0, index),
        <b key={1} style={{ color: '#000' }}>{val}</b>,
        str.substring(index+val.length),
      ];
    } else if(index === 0) {
      return [
        <b key={1} style={{ color: '#000' }}>{str.substring(0, index+val.length)}</b>,
        str.substring(index+val.length)
      ];
    }
    return str;
}

const renderElements = function (item, value) {
    return (
      <div className='cursor'>
        <p className='cityStyle'>
          {
            value ?
              hightLightText(item.city_name || item.display_name, value)
            : item.city_name
          }
          {(item.is_multi_district && item.district) ? ` (${item.district})` : ''}
        </p>
        <p className='stateStyle'>{item.state || ''}</p>
      </div>
    );
};

class InventoryRefreshComponent extends Component{
  
    render(){
      let via_route_support = JSON.parse(localStorage.getItem('via-routes-support')) || this.props.allRoutesInfo.via_route_support;
        return(
             <div className="mainWrapper">
            <div className="row">
                <div className="col-xs-3">
                    <AutoComplete
                    name="source"
                    openOnFocus={true}
                    placeholder="Source *"
                    onSelect={this.props.onSourceItemSelect}
                    defaultValue={this.props.source}
                    fieldName='source'
                    onChange={this.props.fetchCities}
                    renderElements={renderElements}
                    listData={this.props.sourceCityData}
                    />
                </div>
                <div className="col-xs-3">
                    <AutoComplete
                    openOnFocus={true}
                    name="destination"
                    placeholder="Destination *"
                    onSelect={this.props.onDestinationItemSelect}
                    defaultValue={this.props.destination}
                    fieldName='destination'
                    onChange={this.props.fetchCities}
                    renderElements={renderElements}
                    listData={this.props.destCityData}
                    />
                </div>
                <div className="col-xs-2 deal-date-range-wrp padTop7">
                    <SingleDatePicker
                        id="journey_date"
                        daySize={30}
                        showClearDate
                        date={this.props.journeyDate}
                        placeholder="Journey Date"
                        displayFormat="DD-MM-YYYY"
                        focused={this.props.focusedJourneyDate}
                        hideKeyboardShortcutsPanel={true}
                        onDateChange={this.props.onJourneyDateChange}
                        onFocusChange={this.props.onJourneyDateFocusChange}
                        // isOutsideRange={this.props.journeyDateRangeChecker}
                    />
                </div>
                {via_route_support && via_route_support && <div className="col-xs-2 checkbox">
                    <input type="checkbox" 
                    id='inventory_refresh_checkbox'
                    checked={this.props.inventoryRefreshCheckbox}
                    onClick={this.props.onInventoryRefreshCheckBOx}
                      />
                    <label onClick={this.props.onInventoryRefreshCheckBOx} className='checkbox'>Include via routes
                    </label>
                    </div>}
                <div className="col-xs-2 searchButton">
                    <Button label="Submit"  onButtonClick={this.props.onSearchClick}/>
                </div>
            </div>
        </div>)
    }
}


const mapStateToProps = store => ({
  allRoutesInfo: store.userInfoReducer.allRoutesInfo,
})

export default connect(mapStateToProps)(InventoryRefreshComponent)